<svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="-0.5 -0.5 13.5 9.5">
    <path fill="#BABABA" d="M11.56.2a.42.42 0 00-.36-.2H.8a.42.42 0 00-.36.2C.36.32.4.48.48.6l5.2 7.2c.08.12.2.2.32.2s.24-.08.32-.16l5.2-7.2c.04-.08.08-.16.08-.24 0-.08 0-.12-.04-.2z"/>
</svg>
